import { apiUrl } from "@/config/api";
import { tracedFetch } from "@/utils/tracedFetch";

type GetToken = () => Promise<string | null>;

export async function authorizeMcp(
  getToken: GetToken,
  query: string,
): Promise<string> {
  const token = await getToken();
  if (!token) throw new Error("Your Taitora session is unavailable. Please sign in again.");

  const suffix = query.startsWith("?") ? query : `?${query}`;
  const response = await tracedFetch(apiUrl(`/oauth/authorize${suffix}`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message.trim() || `OAuth authorization failed (${response.status})`);
  }

  const body = (await response.json()) as { redirect_to?: unknown };
  if (typeof body.redirect_to !== "string" || !body.redirect_to) {
    throw new Error("OAuth authorization returned no callback URL");
  }
  return body.redirect_to;
}
